const dbRequest = require("../../../../../js-network/db-request");
const multitable = require("../../../../../components/multitable/multitable");
const snack = require("../../../../../components/snack/snack");
const textfieldHandler = require("../../../../../components/textfield/textfield-handler");
const clientSentpaymentSnack = require('./clientSentpayment-snack')

export function getAllInvoice(detail, htmlFc) {
  //console.log('updateCsutomerField -> ', htmlFc)

  let input_customer = htmlFc.fullcontHTML.querySelector(
    "#clientSentpayment_form_provider_id"
  );
  let input_selected = input_customer.getAttribute("selected");

  if (JSON.parse(input_selected).length > 0) {
    load(detail, JSON.parse(input_selected)[0], htmlFc);
  }
}

export function addAmount(detail, htmlFc) {
  // Inicializar el total
  let total_due_amount = 0;
  let total_sent_amount = 0;

  // Obtener todos los checkbox de las filas
  const checkboxes = htmlFc.fullcontHTML.querySelectorAll("#clientSentpayment_form_mt_" + detail.line + " input[type='checkbox']");
  // Obtener todas las filas
  const inputs = htmlFc.fullcontHTML.querySelectorAll("#clientSentpayment_form_payment_vs_po_or_services .line");

  // Obtener el elemento del formulario donde se mostrará el total
  const div_amount_fc = htmlFc.fullcontHTML.querySelector("#clientSentpayment_form_amount .elem");

  // Iterar sobre cada checkbox
  checkboxes.forEach((checkbox) => {
    // Si el checkbox está seleccionado, sumar el valor correspondiente
    if (checkbox.checked) {
      const row = checkbox.closest("#clientSentpayment_form_mt_" + detail.line);
      const due_amount_elem = row.querySelector(".due_amount .elem");

      // Obtener el valor de due_amount y sumarlo al total_due_amount
      const due_amount = parseFloat(due_amount_elem.value) || 0;
      total_due_amount += due_amount;
    }
  });

  // Mostrar el total de due_amount en el input correspondiente (opcional)
  const div_sent_amount = htmlFc.fullcontHTML.querySelector("#clientSentpayment_form_mt_" + detail.line + " .sent_amount .elem");
  div_sent_amount.value = total_due_amount;

  // Sumar todos los valores de los inputs sent_amount
  inputs.forEach((line) => {
    const input_sent = line.querySelector(".sent_amount .elem");
    if (input_sent) {
      total_sent_amount += parseFloat(input_sent.value) || 0;
    }
  });

  // Mostrar el total en el input correspondiente
  div_amount_fc.value = total_sent_amount;

  // Para depuración
  //console.log("Total due amount:", total_due_amount);
  //console.log("Total final de sent amount:", total_sent_amount);
}

export function getAllInvoiceExpenses(detail, htmlFc) {
  //console.log('updateCsutomerField -> ', htmlFc)

  let input_customer = htmlFc.fullcontHTML.querySelector(
    "#clientSentpayment_form_provider_id"
  );
  let input_selected = input_customer.getAttribute("selected");

  if (JSON.parse(input_selected).length > 0) {
    loadExpenses(detail, JSON.parse(input_selected)[0], htmlFc);
  }
}

const load = (detail, value, htmlFc) => {
  return loadDB(detail, value)
    .then((result) => {
      //console.log("pruera");

      //the entity was deleted
      if (result.multiTables[0] === undefined) {
        snack.start({ act: "show", id: "noInvoicePending" });
        multitable.start({ act: "clean", entityMT: htmlFc.entityMT });
        return;
      } /**/

      multitable.start({
        act: "loadResultToForm",
        entityMT: htmlFc.entityMT,
        resultMT: result.multiTables,
      });

      multitable.start({ act: "generator_insert", entityMT: htmlFc.entityMT });
    })
    .catch((error) => {
      throw error;
      //console.log("Error Getting Invoice", error);
    });
}; /**/

async function loadDB(detail, value) {
  detail.inf = { purchase_id: value };

  ///yeison/php/settings.php
  //const result = await dbRequest.start(detail, 'php/settings.php' ) //do the insert
  const result = await dbRequest.start(
    detail,
    "server/php/sql/getAllPurchase.php"
  ); //do the insert

  if (result.status != "ok") {
    throw result;
  }

  return result;
}

export function verifyMultitable(detail, htmlFc) {
  let allInvoice = htmlFc.fullcontHTML.querySelectorAll(
    "#clientSentpayment_form_payment_vs_po_or_services  .line"
  );

  let allInputsEmpty = true;
  let totalAmountSent = 0;
  let input_amount = htmlFc.fullcontHTML.querySelector(
    "#clientSentpayment_form_amount input"
  );

  //let error= false;

  for (const line of allInvoice) {
    let input_sent = line.querySelector(".sent_amount input");

    if (/^(?:[1-9]\d*|0)?(?:\.\d+)?$/.test(input_sent.value) == false) {
      snack.start({ act: "show", id: "invalidValue" });
      textfieldHandler.error(input_sent.closest(".textfield"));
      return false;
    }

    if (input_sent.value.trim() != "" && parseFloat(input_sent.value) != 0) {
      allInputsEmpty = false;
    }

    if (input_sent.value.trim() != "") {
      input_sent.value = parseFloat(input_sent.value);
      totalAmountSent = totalAmountSent + parseFloat(input_sent.value);
    }
  }

  if (allInputsEmpty == true) {
    snack.start({ act: "show", id: "fillInvoiceRequired" });

    allInvoice.forEach(function (line) {
      let input_sent = line.querySelector(".sent_amount input");
      textfieldHandler.error(input_sent.closest(".textfield"));
    });

    return false;
  }

  if (parseFloat(input_amount.value) != totalAmountSent) {
    snack.start({ act: "show", id: "valueEqual" });
    textfieldHandler.error(input_amount.closest(".textfield"));
    return false;
  }

  allInvoice.forEach(function (line) {
    let input_sent = line.querySelector(".sent_amount input");

    if (input_sent.value.trim() == "" || parseFloat(input_sent.value) == 0) {
      line.remove();
    }
  });

  return true;
}

export function validated_press(detail, htmlFc) {
  let input_sent = detail.ev.target;

  if (/^\d+(\.\d+)?$/.test(input_sent.value) == true) {
    textfieldHandler.errorClean(input_sent.closest(".textfield"));
  }
}

// print pdf
export function reportPdf(detail, htmlFc) {
  let elem = document.querySelector("#clientSentpayment-fullcont");
  let dbid = elem.getAttribute("data-dbid");
  let entity = detail.entity
  let report = detail.report

  if (detail.id != "") {
    printPdf({ id: detail.id, type: "print", entity: entity, report: report });
  } else {
    printPdf({ id: dbid, type: "print", entity: entity, report: report });
  }
}

function printPdf(data) {
  const formData = new FormData();
  formData.append('id', data.id);
  formData.append('type', data.type);
  formData.append('entity', data.entity);
  formData.append('reportName', data.report);
  const isPdf = true;

  const controller = new AbortController();
  const timeout = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  // fetch(`./server/php/queries/report/clientSentpayment/pdf-invoice.php`, options)
  fetch(`./server/php/report/report-pdf.php`, options)
    .then((response) => {
      if (!response.ok) throw new Error("report-pdf");
      // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

      return response.blob();
    })
    .then((blob) => {
      if (isPdf) {
        // --- LÓGICA PARA PDF ---
        const pdfBlob = new Blob([blob], { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(pdfBlob);
        const newTab = window.open(fileUrl, "_blank");

        if (newTab) {
          newTab.addEventListener('load', () => {
            URL.revokeObjectURL(fileUrl);
          }, { once: true });
        }
      } else {
        // --- LÓGICA PARA CSV ---
        // Se define el MIME type para CSV
        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
        const fileUrl = URL.createObjectURL(csvBlob);

        // Creamos un enlace temporal en el DOM
        const tempLink = document.createElement("a");
        tempLink.href = fileUrl;

        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
        tempLink.style.display = "none";

        document.body.appendChild(tempLink);
        tempLink.click(); // Disparamos la descarga

        // Limpiamos el DOM y liberamos la memoria
        document.body.removeChild(tempLink);
        URL.revokeObjectURL(fileUrl);
      }
    })
    // .then(response => {
    //   if (!response.ok) {
    //     alert("An error occurred while printing the PDF. Please try again.");
    //   } else {
    //     return response.text(); // Devolver el nombre del archivo PDF generado
    //   }
    // })
    // .then(pdfFileName => {
    //   if (pdfFileName) {
    //     // Ruta base del servidor
    //     const baseUrl = 'https://beestock.gosive.com/server/server/';

    //     // Agregar la parte faltante a la ruta del PDF
    //     const fullPath = pdfFileName.startsWith('server/') ? pdfFileName : 'server/' + pdfFileName;

    //     // Construir la URL absoluta del archivo PDF
    //     const realPdfUrl = new URL(fullPath, baseUrl).href;

    //     // Crear un iframe para cargar el PDF generado
    //     const iframe = document.createElement("iframe");
    //     iframe.style.display = "none";
    //     iframe.src = realPdfUrl;
    //     document.body.appendChild(iframe);

    //     // Esperar a que el PDF se cargue en el iframe antes de imprimir
    //     iframe.contentWindow.print();

    //     //console.log(realPdfUrl)

    //   }
    // })
    .catch(error => {
      throw error;
      //console.log('An error occurred while printing the PDF:', error);
    });
}


//verificar si el sent payment contiene una compra con credito 
export async function verifySentHasPurchaseWithCredit(dbid, htmlFc) {
  let data = { id: dbid };
  const formData = new FormData();
  formData.append('sent_payment_id', data.id);

  const controller = new AbortController();
  const timeout = setTimeout(() => { controller.abort() }, 30000);

  let options = {
    method: 'POST',
    body: formData,
    signal: controller.signal,
    credentials: 'same-origin'
  };

  try {
    const result = await fetch(`./server/php/sql/getPurchasesHasCredit.php`, options);
    const sentData = await result.json();

    if (sentData.restriction.val == "PurchaseHasCredit") {
      clientSentpaymentSnack.start({ act: 'show', id: 'somePurchaseHasCredit' });
      return false;
    } else {
      return true;
    }

  } catch (error) {
    throw error;
  } finally {
    clearTimeout(timeout);
  }
  return false;
}



// bloquea las lineas del MT que contienen Purchase que tienen credito o credito gastado, los COGS no se bloquean
export function blockPurchaseHasCredit(data, htmlFc) {
  //contiene los datos Purchases usados en el receive payment
  let purchaseUsed = JSON.parse(data.purchase_used)[0].data;
  let ifPurchaseCredit = false;

  //busca todas las lineas del mt
  let lines = htmlFc.fullcontHTML.querySelectorAll("#clientSentpayment_form_payment_vs_po_or_services  .line");
  lines.forEach(line => {
    let ac_purchase = line.querySelector(".expense_id")
    let purchase_selected = ac_purchase.getAttribute("selected");
    purchase_selected = JSON.parse(purchase_selected);
    let purcahseOtherField = get_otherField(ac_purchase);

    if (purchase_selected.length > 0) {
      let purchase_id = purchase_selected[0];

      for (let index = 0; index < purchaseUsed.length; index++) {
        //validar que el purchase de la linea del mt este en los purchases usados y que no sean COGS
        if (purchaseUsed[index].purchase_id == purchase_id && purcahseOtherField.type.toUpperCase() != "COGS") {
          //si el purchase usado tiene credito o credito gastado bloquear la linea
          if (parseFloat(purchaseUsed[index].spent_credit) > 0) {
            line.classList.add('multitable-line-blocked');
            line.setAttribute("data-detail", '{"click":   [ {"dest":"textfield", "act":"restriction"  }] }');
            ifPurchaseCredit = true;
            break;
          }
        }
      }
    }
  });

  if (ifPurchaseCredit) {
    clientSentpaymentSnack.start({ act: 'show', id: 'somePurchaseHasCredit' });
  }

}



export function get_otherField(ac_line) {
  try {

    let rawFields = ac_line.querySelector(".otherField");

    if (rawFields == null) {
      throw "Null";
    }

    return JSON.parse(rawFields.getAttribute('otherField'));

  } catch (error) {
    throw error;
    //console.error("Error parsing JSON:", error);
  }
}